<se-fe-card>
  <se-fe-card-header-skeleton
    seFeDataSize="section"
    [seFeDataAction]="true"
    [seFeDataHeavyBorder]="true"
    [seFeDataTitle]="true">
  </se-fe-card-header-skeleton>
  <se-fe-card-content>
    <se-fe-list>
      @for (row of rows; track $index) {
        <se-fe-list-item-skeleton
          seFeDataSize="xsmall"
          [seFeDataSubtitle]="true"
          [seFeDataTitle]="true">
        </se-fe-list-item-skeleton>
      }
    </se-fe-list>
  </se-fe-card-content>
</se-fe-card>
